/* eslint-disable max-len */
/**
 * Transforms the description of a product and adds some bold paragraphs.
 */
export const transformDescription = (description: string): string => {
    const replacements = [
        { pattern: /<p>Das Besondere a/g, replacement: '<p style="font-weight: bold">Das Besondere a' },
        { pattern: /<p>Was Kritiker zu/g, replacement: '<p style="font-weight: bold">Was Kritiker zu' },
        {
            pattern: /<p>Wie der (Wein|Gin|Whiskey|Whisky|Rum|Cognac|Likör|Aperitif|Brandy|Wonderleaf|Prisecco|Traubenpunsch) schmeckt:/g,
            replacement: '<p style="font-weight: bold">Wie der $1 schmeckt:' },
        {
            pattern: /<p>Hinweis: Produkte mit der Bezeichnung .?alkoholfrei.? dürfen laut Gesetzgeber bis zu 0,5 Prozent Alkohol enthalten./g,
            replacement:
                '<p style="font-weight: bold">' +
                'Hinweis: Produkte mit der Bezeichnung „alkoholfrei“' +
                ' dürfen laut Gesetzgeber bis zu 0,5 Prozent Alkohol enthalten.',
        },
    ]

    let transformedDescription = description
    for (const { pattern, replacement } of replacements) {
        transformedDescription = transformedDescription.replace(pattern, replacement)
    }

    return transformedDescription
}
